export const environment = {
  production: true,
  occBaseUrl: null,
  captchaSiteKey: '6Lf73t8UAAAAALmqQmiI5laJTYQ1p3XrZO2xK0T9',
};
